import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import styles from './SignatureSoundBankPage.module.scss';
import Breadcrumbs from '../../components/Breadcrumbs';
import {
    useProductSelection,
    setGetArguments,
    getSelectedProductIdFromCookie,
} from '../../utils/singleProductChooser';

// Components
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroButtonModal from '../../components/HeroButtonModal/HeroButtonModal';
import StreamField from '../../components/StreamField';
import AudioPlayerList from '../../components/AudioPlayerList';
import TabLinksVertical from '../../components/TabLinksVertical';
import RawHtml from '../../components/RawHtml';

const SignatureSoundBankPage = ({
    title,
    hero = {},
    breadcrumbs = {
        links: [],
    },
    settings = {
        header: {},
        footer: {},
    },
    content = [],
    soundDemos,
    soundContent,
    tags,
    tabLinksData = { primary: [], secondary: [] },
    selectedProductId,
    productSelectionOptions,
    download,
    richText
}) => {
    const { selectedProduct, setProductById } = useProductSelection({
        ...productSelectionOptions,
        selectedProductId,
    });

    const cookieValue = getSelectedProductIdFromCookie();
    const hasSoundDemos =
        soundDemos && soundDemos.items && soundDemos.items.length > 0;

    const tabLinks = {
        ...tabLinksData,
        primary: tabLinksData.primary.map((x) => ({
            ...x,
            href: setGetArguments(x.href, cookieValue ? cookieValue : null),
        })),
    };

    const handleLinkClick = (event) => {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'sounds_download',
                collection_name: 'SignatureSoundBankPage',
                sound_name: title,
                product_name: null,
                version: null,
                sample_name: null,
            });
        }
    };

    return (
        <div className={styles['SignatureSoundBankPage']}>
            <Header {...settings.header} />
            <main>
                <div className={styles['SignatureSoundBankPage__Container']}>
                    <div
                        className={
                            styles['SignatureSoundBankPage__Breadcrumbs']
                        }>
                        <Breadcrumbs {...breadcrumbs} />
                    </div>
                    <div
                        className={
                            styles['SignatureSoundBankPage__ContentContainer']
                        }>
                        <div
                            className={
                                styles['SignatureSoundBankPage__Desktop']
                            }>
                            {tabLinks && <TabLinksVertical {...tabLinks} />}
                        </div>
                        <div
                            className={
                                styles['SignatureSoundBankPage__Content']
                            }>
                            {hero && (
                                <HeroButtonModal
                                    onClick={handleLinkClick}
                                    modifiers={['alternative']}
                                    {...hero}
                                    modal={{
                                        buttonText: `Download ${hero.title}`,
                                        downloadLink: { href: download },
                                    }}
                                    tags={tags}
                                />
                            )}
                            <div
                                className={
                                    styles['SignatureSoundBankPage__Mobile']
                                }>
                                {tabLinks && <TabLinksVertical {...tabLinks} />}
                            </div>

                            {richText && (
                                <div
                                    className={
                                        styles['SignatureSoundBankPage__RichText']
                                    }>
                                    <RawHtml html={richText} />
                                </div>
                            )}

                            {hasSoundDemos && (
                                <AudioPlayerList
                                    download={false}
                                    column={true}
                                    {...soundDemos}
                                />
                            )}
                            {soundContent && (
                                <StreamField items={soundContent} />
                            )}
                            {content && <StreamField items={content} />}
                        </div>
                    </div>
                </div>
            </main>
            <Footer {...settings.footer} />
        </div>
    );
};

SignatureSoundBankPage.propTypes = {
    settings: PropTypes.object,
    hero: PropTypes.object,
    breadcrumbs: PropTypes.object,
    tabLinksData: PropTypes.shape({
        primary: PropTypes.array,
        secondary: PropTypes.array,
    }),
    content: PropTypes.arrayOf(PropTypes.object),
    relatedProducts: PropTypes.object,
};

export default basePageWrap(SignatureSoundBankPage);
